import DOMPurify from "dompurify";

// Central HTML sanitizer for any admin-authored CMS/blog content that is
// rendered via dangerouslySetInnerHTML. Strips scripts, event handlers and
// other XSS vectors while keeping formatting tags safe for display.
export function sanitizeHtml(html) {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel"],
    FORBID_TAGS: ["style", "script", "iframe", "form"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "style"],
  });
}

export default sanitizeHtml;
